const DashboardReminderColumns = ({ isMobile }) => [
    {
        field: 'opportunityName',
        headerName: 'Name',
        flex: 1,
        renderCell: ({ row: { opportunityId, opportunityName } }) => (
            <a className="hive-reminder-link" href={`/opportunities/${opportunityId}`}>{opportunityName}</a>
        )
    },
    ...(isMobile ? [] : [
        {
            field: "projectNumber",
            headerName: "Project #",
            flex: 1,
        },
        {
            field: "quoteNumber",
            headerName: "Quote #",
            flex: 1,
        },
        {
            field: "customer",
            headerName: "Customer",
            flex: 1,
        },
        {
            field: "owner",
            headerName: "Owner",
            flex: 1,
            renderCell: ({ row: { owner } }) => owner ? `${owner.firstName} ${owner.lastName}` : 'Unassigned',
            valueGetter: (params) => `${params.firstName} ${params.lastName}`
        },
        {
            field: "revenueLineAmount",
            headerName: "Revenue Amount",
            flex: 1,
            renderCell: ({ row: { revenueLineAmount } }) => revenueLineAmount ? new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            }).format(revenueLineAmount) : '$0.00'
        },
        {
            field: "shipDate",
            headerName: "Ship Date",
            renderCell: ({ row: { shipDate } }) => shipDate ? shipDate.split("T")[0] : "",
            flex: 1
        }
    ]),
    {
        field: "salesStage",
        headerName: "Stage",
        flex: 1,
        renderCell: ({ row: { salesStage } }) => (
            <label className={`badge  ${salesStage === '01 - Lead' ? 'bg-light-primary' : salesStage === '08 - Won' ? 'bg-light-success' : salesStage === '05 - Committee Approval' ? 'bg-light-warning' : salesStage === '04 - Internal Revision' ? 'bg-light-danger' : salesStage === '06 - Quote Sent' ? 'bg-light-primary' : salesStage === '02 - Identified' ? 'bg-light-dark' : salesStage === '03 - Committee' ? 'bg-light-secondary' : salesStage === "07 - External Revision" ? 'bg-light-danger' : 'bg-light-info'}`} style={{ minHeight: '75%', minWidth: '75%', padding: "0", lineHeight: '3', fontSize: '14px' }}>{salesStage}</label>
        ),
    },
];

export default DashboardReminderColumns;
